import React, { Component } from "react";
import { Link } from "react-router-dom";
import map from "lodash/map";

import "./subscription-title.css";

/**
 * @author chargoyao
 * @property {string} linkName link name
 * @property {string} crumb
 * @property {string} btnText button text
 * @property {string} btnClassName button class name
 * @property {function} handleDownload download callback
 */
class SubscriptionInfoTitle extends Component {
  handleDownload() {
    this.props.handleDownload();
  }
  render() {
    const { crumbsLink, crumbs } = this.props;
    return (
      <div className="subscription-info-title clearfix">
        <ul className="clearfix" style={{ width: "100%" }}>
          <li>
            <Link to={"/campaigns?cid=" + this.props.selected_client}>
              {this.props.linkName}
            </Link>
          </li>
          {!crumbs && <li>></li>}
          {map(crumbs, (crumb, index) => {
            return [
              <li style={{ margin: "0 10px" }}> > </li>,
              <li>
                {crumbsLink && crumbsLink[index] ? (
                  <Link to={crumbsLink[index]}>{crumb}</Link>
                ) : (
                  crumb
                )}
              </li>,
            ];
          })}
          {!crumbs && <li>{this.props.crumb}</li>}

          {this.props.showDownloadBtn && (
            <li style={{ float: "right" }}>
              <button
                className="pull-right btn btn-aa-default nav-btn-download-report"
                onClick={e => {
                  e.preventDefault();
                  this.props.handleDownload();
                }}
              >
                Download Report
              </button>
            </li>
          )}
        </ul>
      </div>
    );
  }
}

SubscriptionInfoTitle.defaultProps = {
  linkName: "Dashboard",
  crumbsLink: [],
  btnText: "DOWNLOAD CSV FILE",
  showDownloadBtn: false,
};

export default SubscriptionInfoTitle;



// WEBPACK FOOTER //
// ./src/components/Campaigns/CreateCampaigns/Title/Title.jsx